export const LANG = 'language';
export const AUTH_USER = 'auth.user';
export const AUTH_TENANT = 'auth.tenant';
export const ROOMS_FILTER_TYPE = 'rooms.filter.type';
export const ROOMS_FILTER_STATUS = 'rooms.filter.status';
export const ROOMS_FILTER_QUERY = 'rooms.filter.query';

export function localStorageGet(key) {
  return window.localStorage.getItem(key);
}

export function localStorageGetJSON(key) {
  const data = window.localStorage.getItem(key);
  try {
    return JSON.parse(data);
  } catch (e) {
    return undefined;
  }
}

export function localStorageSet(key, state) {
  if (state !== undefined && state !== null) {
    window.localStorage.setItem(key, isObject(state) ? JSON.stringify(state) : state);
  } else {
    window.localStorage.removeItem(key);
  }
}

function isObject(o) {
  return typeof o === 'object' && o !== null;
}
